import React from "react";

export const ShowStations = ({ stations, closeAction }) => {
  let styles = {
    marginBottom: "20px",
  };
  //Model shows the limit exceed the limit
  return (
    <div className="hoverlay">
      <div className="popup_inner">
        <div className="close_popup">
          <button onClick={closeAction}>X</button>
        </div>
        <div className="popup_content" style={{maxHeight:"70vh", overflow:"auto"}}>
          <div className="popup_txt">
            <ul>
              {stations.map((e) => {
               return <li>{e}</li>;
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./web/components/campaign/ShowStations.jsx